import React from 'react';
import { canonicalFor, usePageMeta } from '../hooks/usePageMeta';
import { PageHeader } from '../components/page/PageHeader';
import { ContentSection } from '../components/page/ContentSection';
import { RelatedLinks } from '../components/page/RelatedLinks';
export function About() {
  usePageMeta({
    title: 'About Robertson Precision | Shear Geometry Tooling',
    description: 'Robertson Precision was founded in 1984 with roots in ultra precision machining. Its USA-made Shear Geometry tooling includes holders, APGX inserts and starter kits.',
    canonical: canonicalFor('/about/')
  });
  return <>
      <PageHeader eyebrow="Company" title="About Robertson Precision" lead="Founded in 1984, with roots in ultra precision machining." crumbs={[{
      label: 'Home',
      href: '/'
    }, {
      label: 'About'
    }]} data-id="element-670" data-mp="2s9bo00996c7t" />

      <ContentSection id="story" data-id="element-671" data-mp="1gx2j8kkyz2cn">
        <div className="rp-measure space-y-5 text-[17px] leading-[1.75] text-graphite/90" data-id="element-672" data-mp="1lukhnh1d1z6e">
          <p data-id="element-673" data-mp="1uhib34kt020w">
            Robertson Precision was founded in 1984. Its roots are in ultra precision
            machining, where tool selection, fixturing and process planning all
            affect the finished part.
          </p>
          <p data-id="element-674" data-mp="23jjc8cj5r87u">
            Shear Geometry is Robertson Precision’s CNC lathe tooling system.
            Our tooling is made in the USA.
            The catalog brings together external tool holders, replaceable APGX
            inserts, starter kits and service parts, with application guidance
            for 6061-T6 aluminum, copper and titanium.
          </p>
          <p data-id="element-675" data-mp="2m8pujyg1hxt4">
            The focus here is practical: identify the tooling, understand the
            published starting guidance and talk through the application. For
            pricing and availability, contact sales; for help with a cutting
            setup, speak with the Shear Geometry technical staff.
          </p>
        </div>
      </ContentSection>

      <RelatedLinks title="Where to next" links={[{
      label: 'Products',
      href: '/products/',
      description: 'Holders, inserts, kits and service parts.'
    }, {
      label: 'Applications',
      href: '/applications/',
      description: 'Aluminum, copper and titanium guidance.'
    }, {
      label: 'Technical Resources',
      href: '/technical-resources/',
      description: 'Technical assistance and references.'
    }, {
      label: 'Contact',
      href: '/contact/',
      description: 'Sales and technical lines.'
    }]} data-id="element-676" data-mp="2r9vn9w9p9l2n" />
    </>;
}